var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3335 28C22.6768 28 21.3335 26.6567 21.3335 25C21.3335 23.3433 22.6768 22 24.3335 22H37.3335V28H24.3335Z",
    fill: "#0496FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 3.3335L11.3335 11.3335H24.6668L18.0002 3.3335Z",
    fill: "#0496FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3332 19.3332H37.3332V17.3332C37.3332 15.1458 36.0012 13.4672 33.9998 12.6665C33.9998 10.4578 32.2085 8.6665 29.9998 8.6665H25.0478L27.2698 11.3332H29.9998C30.7358 11.3332 31.3332 11.9305 31.3332 12.6665C31.3332 13.4025 30.7358 13.9998 29.9998 13.9998H6.6665C5.9305 13.9998 5.33317 13.4025 5.33317 12.6665C5.33317 11.8672 5.94717 11.3332 6.6665 11.3332H8.72984L10.9518 8.6665H6.6665C4.45784 8.6665 2.6665 10.4578 2.6665 12.6665V31.9998C2.6665 34.2085 4.45784 35.9998 6.6665 35.9998H33.3332C35.5518 35.9998 37.3465 34.1945 37.3332 31.9765V30.6665H24.3332C21.2085 30.6665 18.6665 28.1245 18.6665 24.9998C18.6665 21.8752 21.2085 19.3332 24.3332 19.3332Z",
    fill: "#0496FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.d16b6376ce0b51745bd18f6ebed09b58.svg";
export { ForwardRef as ReactComponent };